import { render } from "./TSS.vue?vue&type=template&id=a5e0be06&scoped=true"
import script from "./TSS.vue?vue&type=script&lang=js"
export * from "./TSS.vue?vue&type=script&lang=js"

import "./TSS.vue?vue&type=style&index=0&id=a5e0be06&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e0be06"]])

export default __exports__